import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Privacy-friendly campaign source capture
export function getCampaignSource() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = ["utm_source", "utm_medium", "utm_campaign"].map((k) => p.get(k)).filter(Boolean);
    if (utm.length) return utm.join(" / ");
    if (document.referrer) return `ref: ${new URL(document.referrer).hostname}`;
  } catch (e) {
    console.debug("campaign source unavailable", e);
  }
  return "direct";
}

export async function fetchConfig() {
  const { data } = await client.get("/config");
  return data;
}

export async function submitLead(payload) {
  const { data } = await client.post("/leads", {
    ...payload,
    source_page: window.location.pathname,
    campaign_source: getCampaignSource(),
  });
  return data;
}

export async function submitWhatsAppLead(payload) {
  const { data } = await client.post("/whatsapp/lead", {
    ...payload,
    source_page: window.location.pathname,
    campaign_source: getCampaignSource(),
  });
  return data;
}

export async function trackWhatsAppClick(payload) {
  const { data } = await client.post("/whatsapp/click", {
    ...payload,
    source_page: window.location.pathname,
    campaign_source: getCampaignSource(),
  });
  return data;
}

export async function fetchInsights(params = {}) {
  const { data } = await client.get("/insights", { params });
  return data;
}

export async function fetchInsight(slug) {
  const { data } = await client.get(`/insights/${slug}`);
  return data;
}
